<template>
  <div class="app-container" :class="{ fullscreen: isFullscreen, workspace: isWorkspace }">
    <WorkspaceLayout v-if="isWorkspace" />

    <template v-else>
      <div class="main-container">
        <router-view />
      </div>
    </template>

    <WatermarkDialog v-model="isWatermarkDialogOpen" @saved="handleWatermarkSaved" @close="handleWatermarkClosed" />
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted, onUnmounted } from 'vue';
  import { useRoute } from 'vue-router';
  import WorkspaceLayout from '@/components/layout/workspace/WorkspaceLayout.vue';
  import WatermarkDialog from '@/views/dialog/WatermarkDialog.vue';
  import { useBasicStore } from '@/store';
  import { useWatermarkDialog } from '@/hooks';

  const route = useRoute();
  const basicStore = useBasicStore();
  const isFullscreen = computed(() => route.meta.layout === 'fullscreen');
  const isWorkspace = computed(() => route.meta.layout === 'workspace');

  const { isWatermarkDialogOpen, handleWatermarkSaved, handleWatermarkClosed } =
    useWatermarkDialog();

  function onResize() {
    basicStore.updateUiMode(window.innerWidth);
  }

  onMounted(() => {
    basicStore.updateUiMode(window.innerWidth);
    window.addEventListener('resize', onResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', onResize);
  });
</script>

<style scoped>
  .app-container {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    min-height: 0;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }

  @supports not (height: 100dvh) {
    .app-container {
      height: calc(var(--app-dvh, 1vh) * 100);
    }
  }

  .main-container {
    width: 100%;
    flex: 1 1 0;
    height: 0;
    min-height: 0;
  }

  .fullscreen .main-container {
    height: 100%;
  }
</style>
